import { Control, Controller } from 'react-hook-form';

import { FilterSelect } from '@/components/shared/FilterSelect/FilterSelect';
import { TextField } from '@/components/shared/TextField/TextField';
import { Gender } from '@addmile/backend-client';

import { BlockFormData } from '../schema';

type AuthorFieldsProps = {
  control: Control<BlockFormData>;
};

export const AuthorFields = ({ control }: AuthorFieldsProps) => {
  return (
    <div className="rounded-lg p-4 bg-primary-10 my-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block text-sm font-semibold text-neutral-70 mb-2">Coach Name</label>
          <Controller
            name="author.name"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                placeholder="Coach name"
                className="!w-full"
                inputClassName="!border !border-neutral-20 !font-medium"
              />
            )}
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-neutral-70 mb-2">
            Coach Expertise
          </label>
          <Controller
            name="author.title"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                placeholder="Coach expertise"
                className="!w-full"
                inputClassName="!border !border-neutral-20 !font-medium"
              />
            )}
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-neutral-70 mb-2">Gender</label>
          <Controller
            name="author.gender"
            control={control}
            render={({ field }) => (
              <FilterSelect
                value={field.value as string}
                onChange={(v) => field.onChange(v)}
                className="bg-white-100 h-[38px] w-full"
                options={Object.values(Gender).map((g) => ({
                  value: g,
                  label: g.charAt(0).toUpperCase() + g.slice(1),
                }))}
              />
            )}
          />
        </div>
      </div>
      <div>
        <label className="block text-sm font-semibold text-neutral-70 mb-2">
          Coach Avatar (URL)
        </label>
        <Controller
          name="author.photoUrl"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              placeholder="Coach avatar URL"
              className="!w-full"
              inputClassName="!border !border-neutral-20 !font-medium"
            />
          )}
        />
      </div>
    </div>
  );
};

export default AuthorFields;
